import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./ContentPanel.module.less";
import { useStore } from "../Page";

export const contentPanelId = "contentPanelId";

interface ContentPanelProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  children?: React.ReactNode;
  "data-implicit"?: boolean;
}

const ContentPanel: React.FC<ContentPanelProps> = ({ className, children, ...rest }) => {
  const [state, setState] = useStore();

  const implicitlyUsed = rest["data-implicit"] ?? false;

  React.useLayoutEffect(() => {
    if (!implicitlyUsed) setState((prev) => ({ ...prev, contentPanel: true }));
    return () => {
      setState((prev) => ({ ...prev, contentPanel: false }));
    };
  }, [setState, implicitlyUsed]);

  const contentPanelClassName = cls(
    {
      [styles.contentPanel]: true,
      [styles.contentPanelWithSidePanel]: state.sidePanel,
    },
    className
  );

  return (
    <div {...rest} id={contentPanelId} className={contentPanelClassName}>
      <div className={styles.contentPanelContent}>{children}</div>
    </div>
  );
};

export default ContentPanel;
